export default "__VITE_ASSET__DYPVnPa5__"